import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { SelectExample, SelectAndRadioExample } from '../../components/examples/controls-examples';
import { SelectAPI } from '../../components/api';
export const _frontmatter = {
  "Title": "Select"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SelectApi = makeShortcode("SelectApi");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "select"
    }}>{`Select`}</h1>
    <p>{`Select is a drop-down menu with a limited number of options.`}</p>
    <SelectExample mdxType="SelectExample" />
    <p>{`Select takes the following props:`}</p>
    <SelectApi mdxType="SelectApi" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model
  showTimer={false}
  initialParams={{ options: 'jet' }}
  controls={[
    {
      type: 'select',
      label: 'Choose one',
      param: 'options',
      options: ['jet', 'set', 'radio'],
    },
  ]}
/>
`}</code></pre>
    <SelectAndRadioExample mdxType="SelectAndRadioExample" />
    <p><em parentName="p">{`Select and Radio can be used together on the same param`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      